import { BaseModel } from '@core/data-access';
import { Exclude, Expose } from 'class-transformer';

@Exclude()
export class VerificationGettingStartedModel extends BaseModel {
  @Expose() appId!: string;

  @Expose() last4NRIC!: string;

  @Expose() verifyToken!: string;
}
